import 'bootstrap/dist/css/bootstrap.css'
import 'babel-polyfill'
import React, { Component } from 'react'
import { BrowserRouter, Route, Redirect } from 'react-router-dom'
//import Path from 'path-parser';
import { connect } from 'react-redux'
import * as actions from '../actions'
import ChangePassword from './ChangePassword'
import Header from './Header'
import Landing from './Landing'
import CookieConsent from 'react-cookie-consent'
import Dashboard from './Dashboard'
import FahrerUndUserList from './fahrer/FahrerUndUserList'
import FahrerNew from './fahrer/FahrerNew'
import FuehrerscheinNew from './fahrer/FuehrerscheinNew'
import FuehrerscheinEdit from './fahrer/FuehrerscheinEdit'
import UserList from './user/UserList'
import UserPrefs from './user/UserPrefs'
import NewPassword from './user/UserNewPassword'
import FahrerCSVUpload from './fahrer/FahrerCSVUpload'
import FahrerCSVDownload from './fahrer/FahrerCSVDownload'
import FahrerPdf2 from './fahrer/FahrerPdf2'
import { RegisterPage } from './RegisterPage'
import Login from './login/Login'
import LoginRequestPassword from './login/LoginRequestPassword'
import VideoDisplay from './video/VideoDisplay'
import NurVideo from './video/NurVideo'
import ModalOverlay from './ModalOverlay'
import Footer from './Footer'
import MetaTags from 'react-meta-tags'

class App extends Component {

	componentDidMount() {
 		this.props.fetchUser();
	}

	handleFahrerListe(e) {
		console.log("handleFahrerListe called");
		return "";
	}

// <div className="container" style={{backgroundColor: "#fff"}}>

	render() {
		return (
				<BrowserRouter>
					<div>
						<div className="container">
							<MetaTags>
								<meta name="google-site-verification" content="e2SrlCJA37tJD_3Yw7uRfCHJKiu06G2eP8u2hgDAuzM" />
							</MetaTags>
							<Header />
							<ModalOverlay />
							<Route exact path="/" component={Landing} />
							<Route exact path="/fahrer" component={Dashboard} />
							<Route exact path="/fahrerUndUser" component={FahrerUndUserList} />
							<Route exact path="/test" component={() => <Redirect to="/login" />} />
							<Route exact path="/user" component={UserList} />
							<Route exact path="/user/register" component={RegisterPage} />
							<Route exact path="/user/prefs/:username" component={UserPrefs} />
							<Route exact path="/user/:uid/:email/neues_passwort" component={NewPassword} />
							<Route exact path="/prefs" component={UserPrefs} />
							<Route exact path="/prefs/password" component={ChangePassword} />
							<Route path="/fahrer/new" component={FahrerNew} />
							<Route path="/fahrer/pdf" component={FahrerPdf2} />
							<Route path="/fahrer/csv" component={FahrerCSVDownload} />
							{/*<Route path="/fahrer/batchupload" component={FahrerCSVUpload} />*/}
							<Route path="/fahrer/:email/newFn" component={FuehrerscheinNew} />
							<Route path="/fahrer/:email/:fn/editFn" component={FuehrerscheinEdit} />
							<Route exact path="/login" component={Login} />
							<Route exact path="/login/requirePassword" component={LoginRequestPassword} />
							<Route path="/loginFAILED" component={Landing} />
							<Route exact path="/video/sehen/:vimeoid" component={NurVideo} />
							<Route path="/video/:uid/:email/sehen" component={VideoDisplay} />
						</div>
						<Footer />
						<CookieConsent
							location="bottom"
							style={{ background: '#eee', color: '#333'}}
							buttonStyle={{ background: '#007bff', color: 'white'}}
							buttonText="Ich verstehe">Durch die Nutzung dieser Webseite erklären Sie sich mit der Verwendung von Cookies einverstanden.<br/>
						Näheres finden Sie unter <a href="https://www.allsafe24.com/company/dataprotection/dataprotection_read.action">Datenschutz</a>.</CookieConsent>
					</div>
				</BrowserRouter>
		);
	}
};

function mapStateToProps({ auth }) {
	return { auth }
}

export default connect(mapStateToProps, actions)(App);



// WEBPACK FOOTER //
// ./src/components/App.js